import DebtSettings from "./DebtSettings";
import InvoicingBase from "./InvoicingBase";
import IMDSettings from "./IMDSettings";

export default {
  INVOICING_BASE: InvoicingBase,
  DEBT_SETTINGS: DebtSettings,
  IMD_SETTINGS: IMDSettings,
};
